/**
 * Temporary debugging helper for tracing the lease-term selection event chain.
 *
 * Added to diagnose a client-theme conflict where the unit-card price label does
 * not update after a new lease term is confirmed from the Lease Options modal.
 *
 * The logger walks the full chain so we can see exactly where it breaks:
 *   1. card-lease-term-click  – lease term link clicked on the unit card
 *   2. modal-term-selected    – a term selected inside the modal
 *   3. modal-confirm          – Confirm clicked, override built
 *   4. app-apply-override      – override stored in App state
 *   5. app-render-card         – override applied to card props during render
 *   6. card-pricing-render     – PricingBlock renders the final price label
 *
 * Gated behind the CMS `debug_mode` toggle, surfaced to the app via
 * `SPACES.config.debugMode`. When debug mode is off, every call is a no-op.
 *
 * NOTE: Remove this file and its call sites once the conflict is resolved.
 */

import { getConfig } from '@/data/config'

const PREFIX = '[Spaces:LeaseTerm]'

export type LeaseDebugStep =
	| 'card-lease-term-click'
	| 'modal-term-selected'
	| 'modal-confirm'
	| 'app-apply-override'
	| 'app-render-card'
	| 'card-pricing-render'

function isEnabled (): boolean {
	return getConfig().debugMode === true
}

export function leaseDebug (step: LeaseDebugStep, data?: Record<string, unknown>): void {
	if (!isEnabled()) return
	// eslint-disable-next-line no-console
	console.log(`${PREFIX} ${step}`, data ?? {})
}
